module.exports = __webpack_public_path__ + "img/三艾.png";